import { Controller, useFormContext } from 'react-hook-form'

import { Component } from './components/Component'

import type { MultiSelectProps } from './types'

export const MultiSelect = ({
  name,
  label,
  placeholder,
  required,
  options,
  error,
  hasController = true,
  ...rest
}: MultiSelectProps) => {
  if (hasController) {
    const { control } = useFormContext()

    return (
      <Controller
        name={name}
        control={control}
        render={({ field, formState: { errors } }) => (
          <Component
            name={name}
            label={label}
            placeholder={placeholder}
            required={required}
            options={options}
            error={errors[name]?.message as string}
            value={field.value}
            onChange={(value) => field.onChange(value)}
            {...rest}
          />
        )}
      />
    )
  }

  return (
    <Component
      name={name}
      label={label}
      placeholder={placeholder}
      required={required}
      options={options}
      error={error}
      {...rest}
    />
  )
}
